'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = exports.buttonTypes = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _values = require('lodash/values');

var _values2 = _interopRequireDefault(_values);

var _types = require('./types');

var _argTypes = require('../../utils/argTypes');

var _argTypes2 = _interopRequireDefault(_argTypes);

require('./Button.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Button component using style guidlines from https://fabfitfun.github.io/styleguide/components#buttons
 * @param {object} sysdata - Data object for passing callbacks to the button loaded through the CMS
 * @param {string} label -  Text to go on the button
 * @param {string} type - Type from buttonTypes
 * @param {string} action - Action from actionTypes
 * @param {function} onClick - Method to be passed when component is used outside the CMS
 * @param {boolean} disabled - Condition to disable the button
 */
var Button = (_temp2 = _class = function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this.onButtonClick = function (e) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          id = _this$props.id,
          sysdata = _this$props.sysdata;
      var callBacks = sysdata.callBacks;


      if (sysdata.callBacks && callBacks[id]) {
        callBacks[id](e);
      }

      if (onClick) {
        onClick();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Button, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          label = _props.label,
          type = _props.type,
          action = _props.action,
          id = _props.id,
          disabled = _props.disabled;


      var buttonStyles = (0, _classnames2.default)({
        'shared-button': true,
        'shared-button-cta': type === _types.buttonTypes.PRIMARY.value && action !== _types.actionTypes.CANCEL.value,
        'shared-button-cta-line': type === _types.buttonTypes.SECONDARY.value && action !== _types.actionTypes.CANCEL.value,
        'shared-button-link': type === _types.buttonTypes.LINK.value,
        'shared-button-black': type === _types.buttonTypes.PRIMARY.value && action === _types.actionTypes.CANCEL.value,
        'shared-button-black-line': type === _types.buttonTypes.SECONDARY.value && action === _types.actionTypes.CANCEL.value
      });
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'button',
          {
            id: id,
            className: buttonStyles,
            onClick: function onClick(e) {
              if (disabled) {
                return;
              }

              _this2.onButtonClick(e);
            },
            style: Object.assign({}, this.props.style),
            disabled: disabled
          },
          label
        )
      );
    }
  }]);

  return Button;
}(_react.Component), _class.buttonTypes = _types.buttonTypes, _class.actionTypes = _types.actionTypes, _class.defaultProps = {
  label: 'Button Text',
  type: _types.buttonTypes.PRIMARY.value,
  action: _types.actionTypes.CALL_TO_ACTION.value,
  sysdata: {},
  disabled: false
}, _temp2);


Button.propTypes = {
  sysdata: _propTypes2.default.shape({}),
  label: _propTypes2.default.string,
  type: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  action: _propTypes2.default.string,
  disabled: _propTypes2.default.bool
};

Button.args = [{
  title: 'Label',
  key: 'label',
  type: _argTypes2.default.STRING
}, {
  title: 'Button Type',
  key: 'type',
  type: _argTypes2.default.SELECT,
  options: (0, _values2.default)(_types.buttonTypes)
}, {
  title: 'Action Type',
  key: 'action',
  type: _argTypes2.default.SELECT,
  options: (0, _values2.default)(_types.actionTypes)
}];
exports.buttonTypes = _types.buttonTypes;
exports.actionTypes = _types.actionTypes;
exports.default = Button;

//# sourceMappingURL=Button.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bit/fabfitfun.shared.global.layout-reader/node_modules/@bit/fabfitfun.my-box.global.my-box-header/node_modules/@bit/fabfitfun.shared.global.button/dist/components/Button/Button.js
// module id = 68
// module chunks = 0